jQuery(document).ready(function ($) {
    // Initially, show the items for the first category
    var firstCategoryId = $(".erm_classic_temp-tab").first().data("category_id");
    $(".erm_classic_temp-item").each(function () {
        var itemCategoryId = $(this).data("category_id");
        if (itemCategoryId == firstCategoryId) {
            $(this).show(); // Show items for the first category
        } else {
            $(this).hide(); // Hide items for other categories
        }
    });

    // Handle click event for category tabs
    $(".erm_classic_temp-tab").click(function () {
        var categoryId = $(this).data("category_id");

        // Add 'active' class to clicked tab and remove from others
        $(".erm_classic_temp-tab").removeClass("erm_classic_tem_active");
        $(this).addClass("erm_classic_tem_active");

        // Smooth transition: fade out the items and fade in the selected category
        $(".erm_classic_temp-item").each(function () {
            var itemCategoryId = $(this).data("category_id");
            if (itemCategoryId == categoryId) {
                $(this).stop(true, true).fadeIn(500);  // Fade in items with a 500ms duration
            } else {
                $(this).stop(true, true).fadeOut(500); // Fade out non-matching items with a 500ms duration
            }
        });
    });
});